"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Amplitude = exports.useAmplitude = void 0;
var PropTypes = require("prop-types");
var React = require("react");
var AmplitudeProvider_1 = require("./AmplitudeProvider");
function useAmplitude(eventProperties, instanceName) {
    if (eventProperties === void 0) { eventProperties = {}; }
    if (instanceName === void 0) { instanceName = "$default_instance"; }
    var _a = AmplitudeProvider_1.useAmplitudeContext(), amplitudeInstance = _a.amplitudeInstance, inheritedProperties = _a.eventProperties;
    return React.useMemo(function () {
        function logEvent(eventType, eventPropertiesIn, callback) {
            if (eventPropertiesIn === void 0) { eventPropertiesIn = {}; }
            if (!amplitudeInstance) {
                return;
            }
            var computed = inheritedProperties;
            if (typeof eventProperties === "function") {
                computed = eventProperties(computed);
            }
            else {
                computed = __assign(__assign({}, computed), (eventProperties || {}));
            }
            if (typeof eventPropertiesIn === "function") {
                computed = eventPropertiesIn(computed);
            }
            else {
                computed = __assign(__assign({}, computed), (eventPropertiesIn || {}));
            }
            amplitudeInstance.logEvent(eventType, computed, callback);
        }
        function instrument(eventType, func) {
            function fn() {
                var params = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    params[_i] = arguments[_i];
                }
                var retVal = func ? func.apply(void 0, params) : undefined;
                logEvent(eventType);
                return retVal;
            }
            return fn;
        }
        return {
            logEvent: logEvent,
            instrument: instrument,
            eventProperties: inheritedProperties,
            amplitudeInstance: amplitudeInstance
        };
    }, [eventProperties, amplitudeInstance, inheritedProperties, instanceName]);
}
exports.useAmplitude = useAmplitude;
function Amplitude(props) {
    var _a = useAmplitude(undefined, props.instanceName), logEvent = _a.logEvent, instrument = _a.instrument, eventProperties = _a.eventProperties, amplitudeInstance = _a.amplitudeInstance;
    React.useMemo(function () { return function () {
        if (props.userProperties && amplitudeInstance) {
            amplitudeInstance.setUserProperties(props.userProperties);
        }
    }; }, [props.userProperties, amplitudeInstance])();
    if (!eventProperties) {
        return typeof props.children === "function" ? props.children({ logEvent: logEvent, instrument: instrument }) : props.children || null;
    }
    return (React.createElement(AmplitudeProvider_1.AmplitudeContext.Provider, { value: { eventProperties: __assign(__assign({}, eventProperties), (props.eventProperties || {})), amplitudeInstance: amplitudeInstance } }, typeof props.children === "function" ? props.children({ logEvent: logEvent, instrument: instrument }) : props.children || null));
}
exports.Amplitude = Amplitude;
Amplitude.propTypes = {
    children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
    eventProperties: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
    debounceInterval: PropTypes.number,
    instanceName: PropTypes.string,
    userProperties: PropTypes.object
};
